var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 18.3334H16.6673",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.574 3.0524L12.1919 2.43448C13.2158 1.41068 14.8757 1.41068 15.8995 2.43448C16.9233 3.45828 16.9233 5.11819 15.8995 6.142L15.2815 6.75992M11.574 3.0524C11.574 3.0524 11.6513 4.36548 12.8099 5.52408C13.9685 6.68268 15.2815 6.75992 15.2815 6.75992M11.574 3.0524L5.8932 8.73322C5.50843 9.118 5.31604 9.31039 5.15058 9.52252C4.95541 9.77275 4.78807 10.0435 4.65155 10.33C4.53581 10.5728 4.44977 10.8309 4.27769 11.3472L3.54852 13.5347M15.2815 6.75992L9.60072 12.4407C9.21594 12.8255 9.02356 13.0179 8.81143 13.1834C8.5612 13.3785 8.29045 13.5459 8.00397 13.6824C7.76112 13.7981 7.503 13.8842 6.98677 14.0562L4.79926 14.7854M4.79926 14.7854L4.26455 14.9637C4.0105 15.0483 3.73042 14.9822 3.54107 14.7929C3.35172 14.6035 3.2856 14.3234 3.37028 14.0694L3.54852 13.5347M4.79926 14.7854L3.54852 13.5347",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.ec0ccff5d1e9564e527102588d9a4e05.svg";
export { ForwardRef as ReactComponent };